<div #columnMenuRef class="filters-menu">
  <!-- FILTER MENU HEADER -->
  <div class="menu-header">
    <nb-icon *ngIf="icon" icon="{{icon}}" pack="icomoon" class="icon"></nb-icon>
    <p [ngClass]="{'noMargin' : !icon}">{{ 'view_translations.' + menuTitle | translate | titlecase }}</p>
    <div
      class="tooltip-button tool-tip tile-tooltip"
      [ngbTooltip]="('statistics_table_column_tooltip_' + columnName) | t"
      container="body"
      placement="bottom-left"
      tooltipClass="my-configurations-tooltip">
      <nb-icon icon="info" pack="icomoon" class="info-icon"></nb-icon>
    </div>
    <button class="close-button btn" (click)="closeMenuHandler(menuName ?? '')">
      <nb-icon icon="cross" pack="icomoon" class="icon"></nb-icon>
    </button>
    <div *ngIf="enableCleanFilters" class="basket-wrapper" (click)="cleanFilters()">
      <nb-icon icon="basket" pack="icomoon" class="icon basket"></nb-icon>
    </div>
    <div class="desc" *ngIf="desc">{{desc}}</div>
  </div>
  <ng-container *ngFor="let filterOption of filterMenuOptions">
    <!-- FILTER MENU ELEMENTS - SORT-->
    <div class="sort" *ngIf="filterOption.category === 'sort'">
      <p class="title">
        {{ 'view_translations.sort' | translate }}
        <span class="unactive" *ngIf="filterOption.values[0].orderField !== activeSortMethod.orderField"> {{ 'view_translations.unactive' | translate }} </span>
      </p>
      <div class="filter-elements">
        <div
          class="element global-transition"
          *ngFor="let option of filterOption.values"
          [ngClass]="{'active' : option.orderField === activeSortMethod.orderField && option.orderType === activeSortMethod.orderType}">
          <label class="filter-element global-transition">
            <input
              type="checkbox"
              (click)="selectSortMethod(option)"
              [checked]="option.orderField === activeSortMethod.orderField && option.orderType === activeSortMethod.orderType" />
            <div class="element-text global-transition">
              {{ 'view_translations.' + option.name | translate | titlecase}} {{ option.additional ? ('view_translations.' + option.additional | translate |
              lowercase) : '' }}
            </div>
            <span
              class="checkmark ratio global-transition"
              [ngClass]="{'checked' : option.orderField === activeSortMethod.orderField && option.orderType === activeSortMethod.orderType}">
            </span>
            <div class="icon-wrapper global-transition">
              <nb-icon icon="{{ option.orderType === 'desc' ? 'sort' : 'sort-alt' }}" pack="icomoon" class="icon"></nb-icon>
            </div>
          </label>
        </div>
      </div>
    </div>
    <!-- FILTER MENU ELEMENTS - SEARCH INPUT-->
    <div class="search-wrapper" *ngIf="filterOption.category === 'searchInput'">
      <p class="title">{{ 'view_translations.' + filterOption.name | translate }}</p>
      <input
        *ngIf="filterOption.searchMethod === 'id'; else otherInputTypeAllowed"
        appOnlyNumbersInput
        type="text"
        [id]="'search_' + filterOption.name"
        placeholder="{{ 'view_translations.input_label' | translate }}"
        class="name-input"
        [ngModel]="getModel(filterOption?.name ?? '')"
        (keyup)="searchByNameOrIDHandler($event, filterOption)" />
      <ng-template #otherInputTypeAllowed>
        <input
          type="text"
          [id]="'search_' + filterOption.name"
          placeholder="{{ 'view_translations.input_label' | translate }}"
          class="name-input"
          [ngModel]="getModel(filterOption?.name ?? '')"
          (keyup)="searchByNameOrIDHandler($event, filterOption)" />
      </ng-template>
    </div>
    <!-- FILTER MENU ELEMENTS - SEARCH WITH DROPDOWN-->
    <div class="search-wrapper" *ngIf="filterOption.category === 'selectWithSearch'">
      <p class="title">{{ 'view_translations.' + filterOption.name | translate }}</p>
      <app-input-select
        [placeholder]="'select_campaigns' | t"
        [options]="selectOptionsCampaigns"
        [multiple]="true"
        [large]="false"
        [inputStyle]="true"
        [search]="true"
        (emitChange)="filterOption.type?.includes('admin')? selectAdminCampaign($event) : selectCampaign($event)">
      </app-input-select>
    </div>
    <!-- FILTER MENU ELEMENTS - CHECKBOX LIST-->
    <ng-container *ngIf="filterOption.category === 'checkboxesList'">
      <div
        class="display-options"
        *ngFor="let category of Object.keys(filterOption.values)"
        [ngClass]="{'noBorder' : tableTitle === 'configurations_stats' || tableTitle === 'leads' || tableTitle === 'visits' || tableTitle === 'countries' || tableTitle === 'referrals' || menuTitle === 'Ml_sub'}">
        <p class="checkbox-error" *ngIf="checkboxError">{{ 'atleast_one_item_required' | t }}</p>
        <p class="title">{{ 'view_translations.' + category | translate }}</p>
        <div class="filter-elements">
          <div class="element" *ngFor="let option of selectedOptions[category]; index as i" [ngClass]="{'active' : option.checked}">
            <label class="filter-element">
              <input type="checkbox" name="{{ option.text }}" [checked]="option.checked" (change)="selectOption($event, option, category)" />
              <div class="element-text global-transition">{{ option.noTranslation ? option.text : 'view_translations.' + option.text | translate }}</div>
              <span class="checkmark global-transition"></span>
              <div class="icon-wrapper" [ngClass]="option.text" *ngIf="option.icon">
                <nb-icon icon="{{ option.icon }}" pack="icomoon" class="icon"></nb-icon>
              </div>
            </label>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- FILTER MENU ELEMENTS - SLIDER -->
    <div class="range-slider" [ngClass]="{'giveMeBorder' : menuTitle === 'campaign'}" *ngIf="filterOption.category === 'slider'">
      <p class="title">{{ 'view_translations.' + filterOption.name | translate }}</p>
      <app-stats-slider
        #Slider
        [menuTitle]="menuTitle ?? ''"
        [currency]="currency ?? ''"
        [filterOption]="filterOption"
        [rangeStep]="filterOption.rangeStep"
        [minValue]="filterOption.minValue ?? 0"
        [maxValue]="filterOption.maxValue ?? 0">
      </app-stats-slider>
    </div>
    <!-- FILTER MENU ELEMENTS - COUNTRIES -->
    <ul class="countries-list" *ngIf="filterOption.category === 'countriesSelect'" id="countriesList" (scroll)="checkIfScrolled()">
      <li
        class="list-item"
        *ngFor="let country of countryList | slice : 0 : sliceCountriesTo"
        (click)="selectCountry(country)"
        [ngClass]="{'active' : checkIfCountryActive(country.code)}">
        <div class="flag-icon-wrapper">
          <img class="flag-icon" src="{{ 'assets/icons/flags/' + country.code.toLowerCase() + '.png' }}" alt="{{ country }}" />
        </div>
        {{ country.translate }}
        <nb-icon icon="check-circle" pack="icomoon" class="checked-icon" [ngClass]="{'visible' : checkIfCountryActive(country.code)}"></nb-icon>
      </li>
    </ul>
  </ng-container>

  <div class="menu-footer">
    <div class="btn-container">
      <app-primary-button
        [fontSize]="10"
        [height]="40"
        (emitAction)="applyFilter()"
        [disabled]="checkboxError"
        background="orange"
        buttonText="apply_filter"></app-primary-button>
    </div>
    <button class="btn cancel" (click)="closeMenuHandler(menuName ?? '')">{{ 'view_translations.cancel' | translate}}</button>
  </div>
</div>
